/*** IMPORTS FROM imports-loader ***/
var jquery = require("jquery");
var moment = require("moment");

'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
/* eslint-disable consistent-return */
/**
 * Custom React PropType for date values.
 * Since the JS `instanceof` operator does not work across realms
 * (e.g. it would not recognize a Date passed from a child window or frame),
 * this does some extra typing if it fails that test.
 *
 */

var dateSignature = '[object Date]';
var toString = Object.prototype.toString;
function requiredDate(props, propName, componentName) {
	var value = props[propName];
	if (!(value instanceof Date) || toString.call(value) !== dateSignature) {
		return new Error('Invalid prop `' + propName + '` supplied to `' + componentName + '`.' + ('`' + propName + '` must be a valid Date, was `' + value + '`.'));
	}
}

function optionalDate(props, propName, componentName) {
	if (props.hasOwnProperty(propName) && props[propName] !== undefined) {
		return requiredDate(props, propName, componentName);
	}
}

optionalDate.isRequired = requiredDate;

exports.default = optionalDate;



//////////////////
// WEBPACK FOOTER
// /walletexpnodeweb-ci-6534/workspace/consumerweb-release/~/component-datepicker/dist/date-proptype.js
// module id = 785
// module chunks = 0